import { render } from "./CurrencySelect.vue?vue&type=template&id=19c74fd5"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"
script.render = render

export default script